import { Icon } from './Icon'
import type { IconProps } from './Icon'
export const PictureInPictureIcon = (p: IconProps) => <Icon {...p}><path d="M2 4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4z" /><path d="M12 9h6v6h-6V9z" /><path d="M6 19v2" /><path d="M18 19v2" /><path d="M10 21h4" /></Icon>
